<template lang="pug">
section.LndAchs
  h2(v-html="L.header")
  ul.d-flex.t-miniscroll(ref="slider", :class="!mq.sm && '--spread --wrap'")
    li(v-for="item of L.list")
      .__img
        img(v-if="item.img", :srcset="`${ item.img } 1.5x`", :alt="item.txt")
        Svgi(v-else-if="item.$svg", :name="item.$svg")
      span {{ item.txt }}
  //- .d-sm.d-flex.__ctrs
    BtnArrow(dir="left", @click="slide(-1)")
    BtnArrow(dir="right", @click="slide(1)")
</template>
<script>
import BtnArrow from 'components/BtnArrow';
// import { bindScrollSlide } from 'utils';
import content from 'content';
// import { OS } from 'const';

export default {
  name: 'LndAchs',
  inject: ['mq'],

  static: () => ({
    L: content.achs,
  }),

  // mounted () {
  //   // this.slide = bindScrollSlide(this.$refs.slider, { dist: OS === 'iOS' ? 254 : 190, dur: 400 });
  //   this.slide = bindScrollSlide(this.$refs.slider, { dist: 254, dur: 400 });
  // },

  // components: {
  //   BtnArrow,
  // },
};

</script>
<style>
.LndAchs {
  h2 {
    margin-bottom: 40px;
  }
  ul {
    --gap-h: 18px;
    --gap-v: 22px;

    li {
      /*--gap-h: 30px;*/
      flex-shrink: 0;
      flex-grow: 0;
      flex-basis: 178px;
      justify-content: space-between;
      /*padding: 49px 25px;*/

      span {
        display: flex;
        align-items: center;
        width: 100%;
        height: 104px;
        font-size: 14px;
        line-height: 23px;
        letter-spacing: -0.065em;
        border-bottom: 1px solid var(--sep-c);
      }

      .__img {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 163px;

        background: var(--bg-c);
        border-bottom: 1px solid var(--sep-c);
      }

      /*&:nth-child(3) .__img { opacity: .6; }*/

      &:nth-child(6) svg {
        width: 48px;
        height: 48px;

        opacity: .5;

        filter: invert(1);
      }
    }
  }
}

@media (min-width: 740px) {
  .LndAchs {
    li {
      align-items: center;
    }

    .__img {
      display: flex;
      justify-content: center;
    }
  }
}

@media (max-width: 739px) {
  .LndAchs {

    h2 { margin-bottom: 50px }
    ul {
      margin: 0 calc(-1 * var(--page-pad));
      padding: 0 var(--page-pad) var(--page-pad);

      overflow-x: auto;
      overflow-x: overlay;
      scroll-snap-type: x mandatory;
      scroll-behavior: smooth;
    }

    li {
      /*align-items: flex-start;*/
      /*min-width: 230px;*/

      scroll-snap-align: center;
    }

    svg[data-name="soc-fb"] {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
